/**
 * Checks whether an error represents an aborted/cancelled HTTP request
 * (e.g. due to page navigation while a Knock API call is in flight).
 */
export function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }

  if (!(error instanceof Error)) {
    return false;
  }

  const axiosCode = (error as Error & { code?: string }).code;
  if (axiosCode === "ECONNABORTED" || axiosCode === "ERR_CANCELED") {
    return true;
  }

  const message = error.message.toLowerCase();
  return (
    message.includes("request aborted") ||
    message.includes("request cancelled") ||
    message.includes("request canceled") ||
    message.includes("network error")
  );
}
